export const getToken = () => {
  return window.localStorage.getItem(process.env.VUE_APP_TOKEN_NAME);
};

export const saveToken = token => {
  window.localStorage.setItem(process.env.VUE_APP_TOKEN_NAME, token);
};

export const destroyToken = () => {
  window.localStorage.removeItem(process.env.VUE_APP_TOKEN_NAME);
};

export default { getToken, saveToken, destroyToken };
